<template>
    <iframe src="../quest/Fizika-1.0-web/index.html" frameborder="0"></iframe>
</template>
<script>
    export default {
    name: "FizikQuest"
    };
</script>
<style scoped>
    iframe {
        width: 100%;
        height: 100vh;
        border: none;
    }
</style>